import styled, { createGlobalStyle } from 'styled-components';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export const GlobalStyled = createGlobalStyle`
  * {
    box-sizing: border-box;
    font-family: "VodafoneRg";
  }

  @media screen and (max-width: 480px) {
    body, #__next {
      min-height: 100vh;
      display: flex;
      flex-direction: column;
    }

    section {
      flex: 1;
    }
  }

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    font-family: 'VodafoneRg';
  }

  @font-face {
    font-family: 'VodafoneRg';
    src: local('Vodafone Regular'), local('Vodafone-Regular'),
    url('https://cms.vodafone.com.tr/static/document/23-07/10/vodafonerg-_1_.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  /* Light */
  @font-face {
    font-family: 'VodafoneLt';
    src: local('Vodafone Light'), local('Vodafone-Light'),
    url('https://cms.vodafone.com.tr/static/document/23-07/10/vodafonerg-_1_.woff') format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  /* Bold */
  @font-face {
    font-family: 'VodafoneBold';
    src: local('Vodafone Bold'), local('Vodafone-Bold'),
    url('https://cms.vodafone.com.tr/static/document/23-07/10/vodafonerg-_1_.woff') format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  /* Extra Bold */
  @font-face {
    font-family: 'VodafoneBolder';
    src: local('Vodafone Extra Bold'), local('Vodafone-Extra-Bold'),
    url('https://cms.vodafone.com.tr/static/document/23-07/10/vodafonerg-_1_.woff') format('woff');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }
  
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  body {
    line-height: 1;
  }

  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
  @media screen and (max-width: 480px) {
    position: relative;
  }
`;

export const LoadingCircle = styled.div`
  margin: 20px auto;
  font-size: 10px;
  text-indent: -9999em;
  border: 1.1em solid #f3f3f3;
  border-top: 1.1em solid #e60000;
  transform: translateZ(0);
  -webkit-animation: 1.1s linear infinite spin;
  animation: 1.1s linear infinite spin;
  right: 0;
  bottom: 0;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
